// extracted by mini-css-extract-plugin
export default {"container":"CampaignTabsContent_container__IoKoU"};